/**
 * 存储认证监听器 - 监听 storage 事件，处理跨窗口会话同步和权限校验
 * 当检测到存储变化时（如其他窗口登出），自动清除本地会话并重定向到登录页
 */
import router from '@/router'
import store from '@/store/index.js'
import resetRouter from './resetRouter'

window.addEventListener('storage', e => {
    // sessionStorage.setItem(e.key, e.oldValue)
    sessionStorage.clear()
    resetRouter()
    router.push('/login')
    store.commit('setIsAddRoutes', false)
})
